import { ApiResponseError } from '@sparklayer-io/spark-dash-core/types/errors';
import z from '@sparklayer-io/spark-dash-core/zod';

const authValidationErrorSchema = z.object({
  message: z.string().optional(),
  errors: z.record(z.string(), z.array(z.string())),
});

export type AuthValidationError = z.infer<typeof authValidationErrorSchema>;

export function isAuthValidationError(err: unknown): err is ApiResponseError<AuthValidationError> {
  return ApiResponseError.isApiResponseError(err, authValidationErrorSchema);
}
